import React, { useRef, useEffect, useState } from 'react';
import './TorchEffect.css';

const TorchEffect = ({
  children,
  autoHeight = false,
  containerWidth = '100%',
  whiteBG = false // 👈 add whiteBG prop
}) => {
  const containerRef = useRef(null);
  const torchRef = useRef(null);
  const overlayRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const torch = torchRef.current;
    const overlay = overlayRef.current;

    if (!container || !torch || !overlay) return;

    overlay.style.opacity = '1';

    const handleMouseMove = (e) => {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      torch.style.left = x + 'px';
      torch.style.top = y + 'px';
      if (whiteBG) {
        overlay.style.maskImage = `radial-gradient(circle at ${x}px ${y}px, transparent 0%, rgba(0, 0, 0, 0.95) 100px)`;
        overlay.style.webkitMaskImage = `radial-gradient(circle at ${x}px ${y}px, transparent 0%, rgba(0, 0, 0, 0.95) 100px)`;
      } else {
        overlay.style.maskImage = `radial-gradient(circle at ${x}px ${y}px, rgba(0,0,0,0.4) 0%, black 100px)`;
        overlay.style.webkitMaskImage = `radial-gradient(circle at ${x}px ${y}px, rgba(0,0,0,0.4) 0%, black 100px)`;
      }
    };

    const handleMouseLeave = () => {
      torch.style.opacity = '0';
      overlay.style.maskImage = 'none';
      overlay.style.webkitMaskImage = 'none';
    };

    container.addEventListener('mousemove', handleMouseMove);
    container.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      container.removeEventListener('mousemove', handleMouseMove);
      container.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  // 🔁 Class helper
  const getClass = (base) => (whiteBG ? `${base}-white` : base);

  return (
    <div
      className={`${getClass('torch-bg-container')} ${!autoHeight ? 'h-[110vh] max-h-[900px]' : 'h-auto'
        }`}
      ref={containerRef}
    >
      <div className="torch-container">
        <div className={getClass('persistent-overlay')} ref={overlayRef} />
        <div className="torch-highlight" ref={torchRef} />
        <div
          className={`${getClass('torch-bg-overlay')} ${!autoHeight ? 'h-[100vh]' : ''
            }`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default TorchEffect;
